import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}



// 


$(document).ready(function() {
  function addToCart(variantId, sellingPlanId = null, quantity = 1) {
    const data = {
      id: variantId,
      quantity: quantity
    };

    if (sellingPlanId) data.selling_plan = sellingPlanId;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(response) {
        console.log("✅ Added to cart:", response);

        const cartEvent = new CartAddEvent({}, variantId.toString(), {
          source: 'custom-button',
          itemCount: quantity,
          productId: response.product_id
        });

        document.dispatchEvent(cartEvent);
      },
      error: function(err) {
        console.error("❌ Error adding to cart:", err);
        alert("Something went wrong. Please try again.");
      }
    });
  }

  $('.add-to-cart-button').on('click', function(e) {
    e.preventDefault();
    // const $selectedVariant = $('input[ref="variantId"]');
    let $selectedVariant;
    if($('body').hasClass('template-product')){
       $selectedVariant = $('input[ref="variantId"]');
    }else{
       $selectedVariant = $(this).parents('form').find('input[ref="variantId"]');
    }
    let quantity;
    quantity = $(this).parents('form').find('.quantity-selector input').val() || 1;

    // const $selectedVariant = $(this).parents('form').find('input[ref="variantId"]');
    if (!$selectedVariant.length) {
      alert('Please select a variant.');
      return;
    }

    const variantId = $selectedVariant.val();
    const purchaseType = $('.sub-option.active input[name="purchase_option"]').val();
    const sellingPlanId = (purchaseType === 'subscribe') ? $('#selling_plan').val() : null;

    addToCart(variantId, sellingPlanId, quantity);
  });
});